var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-results-suggestions"},[_c('div',{staticClass:"h3 mb-4 text-left"},[_vm._v("Oops! Non abbiamo trovato risultati.")]),_c('date-suggestions'),_c('flights-suggestions')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }